import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './navbar.css';

const Navbar = ({ activeButton, setActiveButton, scrollToSection }) => {
  const { t, i18n } = useTranslation();
  const [isScrolling, setIsScrolling] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 900);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 900);
      if (window.innerWidth > 900) {
        setIsMenuOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleButtonClick = (buttonName, sectionId) => {
    setActiveButton(buttonName);
    scrollToSection(sectionId);
    if (isMobile) setIsMenuOpen(false);
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleExternalLink = () => {
    window.location.href = 'https://motonurk.ee';
  };

  useEffect(() => {
    const handleScroll = () => {
      if (isScrolling) return;

      const sections = ['hero', 'museum-night-2026', 'finno-wheel-2026', 'support'];
      let currentSection = '';

      sections.forEach((sectionId) => {
        const section = document.getElementById(sectionId);
        if (section) {
          const rect = section.getBoundingClientRect();
          if (rect.top <= 100 && rect.bottom >= 100) {
            currentSection = sectionId;
          }
        }
      });

      switch (currentSection) {
        case 'hero':
          setActiveButton(null);
          break;
        case 'museum-night-2026':
          setActiveButton('museumNight2026');
          break;
        case 'finno-wheel-2026':
          setActiveButton('finnoWheel2026');
          break;
        case 'support':
          setActiveButton('support');
          break;
        default:
          setActiveButton(null);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [isScrolling, setActiveButton]);

  return (
    <div className="navbar-container">
      <nav className="navbar">
        <div className="navbar-left">
          <div className="navbar-logo" onClick={scrollToTop}>
            <img
              src="/logo.png"
              alt="Logo"
              className="logo-image"
            />
          </div>
          

          {isMobile && (
            <div className="navbar-external-logo" onClick={handleExternalLink}>
              <img
                src="/MotonurkLogoWhite.png"
                alt="External Link"
                className="external-logo-image"
              />
            </div>
          )}
        </div>

        {!isMobile && (
          <div className="navbar-buttons">
            {[
              { name: 'museumNight2026', label: t('navbar.museumNight2026'), sectionId: 'museum-night-2026' },
              { name: 'finnoWheel2026', label: t('navbar.finnoWheel2026'), sectionId: 'finno-wheel-2026' },
            ].map(({ name, label, sectionId }) => (
              <div
                key={name}
                className={`navbar-button ${activeButton === name ? 'active' : ''}`}
                onClick={() => {
                  setIsScrolling(true);
                  handleButtonClick(name, sectionId);
                  setTimeout(() => setIsScrolling(false), 500);
                }}
              >
                {label}
              </div>
            ))}
            {/* Старое меню сохранено для восстановления:
            {['program', 'news', 'retroTech', 'fair', 'finnoWheel', 'accommodation', 'gallery'].map(...)}
            */}
          </div>
        )}

        <div className="navbar-right">

          {!isMobile && (
            <div className="navbar-external-logo" onClick={handleExternalLink}>
              <img
                src="/MotonurkLogoWhite.png"
                alt="External Link"
                className="external-logo-image"
              />
            </div>
          )}
          
          <div className="navbar-languages">
            {['et', 'en', 'ru', 'lv'].map((language) => (
              <span
                key={language}
                className={language === i18n.language ? 'active-language' : ''}
                onClick={() => i18n.changeLanguage(language)}
              >
                {language}
              </span>
            ))}
          </div>

          {isMobile && (
            <div 
              className="navbar-menu-toggle"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              <div className={`menu-icon ${isMenuOpen ? 'open' : ''}`}>
                <span></span>
                <span></span>
                <span></span>
              </div>
            </div>
          )}
        </div>

        {isMobile && isMenuOpen && (
          <div className="navbar-mobile-menu">
            {[
              { name: 'museumNight2026', label: t('navbar.museumNight2026'), sectionId: 'museum-night-2026' },
              { name: 'finnoWheel2026', label: t('navbar.finnoWheel2026'), sectionId: 'finno-wheel-2026' },
            ].map(({ name, label, sectionId }) => (
              <div
                key={name}
                className={`navbar-button ${activeButton === name ? 'active' : ''}`}
                onClick={() => {
                  setIsScrolling(true);
                  handleButtonClick(name, sectionId);
                  setTimeout(() => setIsScrolling(false), 500);
                }}
              >
                {label}
              </div>
            ))}
          </div>
        )}
      </nav>
    </div>
  );
};

export default Navbar;
